import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { flatten190t3gjqiixdz as flatten } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCacheReadable.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  notNullOrElse323gzwh5eb92x as notNullOrElse,
  WhenNull1z9qwiohnufo5 as WhenNull,
} from '../sdk/NonNullModelCacheItem.mjs';
import { Draftazcheef5x425 as Draft } from '../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Draft_0(id, cache) {
  var tmp = flatten(remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return cache($this$remember).watch_h7bemi_k$(id);
  }));
  var tmp_0 = () => {
    throw Exception().new_kotlin_Exception_hsqbop_k$('No item found with id ' + toString(id));
  };
  return Draft(notNullOrElse(tmp, new (sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0())(tmp_0)));
}
var sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class;
function sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0() {
  if (sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      invoke_naf6l2_k$() {
        return this.function_1().raw_1;
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, WhenNull()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0', VOID, VOID, [WhenNull(), FunctionAdapter()]);
    sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class = $;
  }
  return sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class;
}
//region block: exports
export {
  Draft_0 as Draft3goc8q7vggbic,
};
//endregion

//# sourceMappingURL=Draft.ext.mjs.map
